<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPause_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.302 3A2.302 2.302 0 0 0 5 5.302v13.396a2.302 2.302 0 0 0 4.605 0V5.302A2.302 2.302 0 0 0 7.302 3Zm9.21 0a2.302 2.302 0 0 0-2.303 2.302v13.396a2.302 2.302 0 1 0 4.605 0V5.302A2.302 2.302 0 0 0 16.512 3Z"
        clip-rule="evenodd"
    />
</svg>
